import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../Utilitie";
import FailedMsg from "../../Extra/FailedMsg";
import SuccessMsg from "../../Extra/SuccessMsg";

const TWSBlockUpdate = () => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [entries, setEntries] = useState([]);
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const keys = [
    "Sr no.",
    "reportDate",
    "Direction",
    "section",
    "From_Station",
    "To_Station",
    "Yard",
    "Block_Type",
    "MAIN_LOOP_LINE",
    "CrossOver",
    "SPEED_POTENTIAL",
    "REMARKS",
  ];

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getTWSData?start=${startDate}&end=${endDate}`
      );
      if (response.data.status === "ok") {
        setEntries(response.data.daterange.data);
      } else {
        setEntries([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchedData();
  }, []);

  const handleChange = (index, key, value) => {
    setEntries((prev) => {
      const newEntries = [...prev];
      newEntries[index] = { ...newEntries[index], [key]: value };
      return newEntries;
    });
  };

  const handleClear = () => {
    setEntries((prev) => prev.map((row) => ({ ...row, no_of_crack: "" })));
  };

  const handleSubmit = async () => {
    const TWSData = entries.map(
      ({
        Block_Type,
        Direction,
        From_Station,
        Sno,
        To_Station,
        reportDate,
        section,
        ...rest
      }) => ({
        ...rest,
      })
    );

    try {
      const response = await fetch(`${urlPrefixBlock}updateTWSData`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(TWSData),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to upload data. HTTP status: ${response.status}`
        );
      }
      const output = await response.json();
      setResult(output);
      setShow(true);
      handleClear();
    } catch (error) {
      console.error("Error submitting TWS data:", error);
      setShow(true);
    }
  };

  return (
    <div className=" m-3">
      <div className="d-flex justify-content-between bg-dark text-white p-1 papaDiv">
        <h5 className="ms-5">TWS Block Update </h5>
        <div>
          <div className="d-flex  align-items-center ">
            <b>From </b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
            />

            <b>To </b>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={fetchedData}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>
      {entries.length === 0 ? (
        <div className="text-center mt-4">
          <h5 className="text-muted">Please select a date to load data.</h5>
        </div>
      ) : (
        <div className="table-responsive papaDiv m-2">
          <table className="table table-bordered table-striped m-0">
            <thead className="table-dark text-center align-middle sticky-top">
              <tr>
                {keys.map((key) => {
                  return (
                    <th key={key} className="border-white">
                      {key.toUpperCase().replace(/_/g, " ")}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {entries.map((row, index) => (
                <tr key={row.TWS_ID}>
                  <td>{index + 1}</td>
                  <td>{row.reportDate.slice(0, 10)}</td>
                  <td>{row.Direction}</td>
                  <td>{row.section}</td>
                  <td>{row.From_Station}</td>
                  <td>{row.To_Station}</td>
                  <td>
                    {row.From_Station == row.To_Station ? "YARD" : "SECTION"}
                  </td>
                  <td>{row.Block_Type}</td>
                  {/* <td>{row.MAIN_LOOP_LINE}</td>
                  <td>{row.CrossOver}</td>
                  <td>{row.SPEED_POTENTIAL}</td>
                  <td>{row.REMARKS}</td> */}
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      style={{
                        height: "26px",
                        padding: "2px 6px",
                        fontSize: "0.8rem",
                      }}
                      value={row.MAIN_LOOP_LINE || ""}
                      onChange={(e) =>
                        handleChange(index, "MAIN_LOOP_LINE", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      style={{
                        height: "26px",
                        padding: "2px 6px",
                        fontSize: "0.8rem",
                      }}
                      value={row.CrossOver || ""}
                      onChange={(e) =>
                        handleChange(index, "CrossOver", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      style={{
                        height: "26px",
                        padding: "2px 6px",
                        fontSize: "0.8rem",
                      }}
                      value={row.SPEED_POTENTIAL || ""}
                      onChange={(e) =>
                        handleChange(index, "SPEED_POTENTIAL", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      style={{
                        height: "26px",
                        padding: "2px 6px",
                        fontSize: "0.8rem",
                      }}
                      value={row.REMARKS || ""}
                      onChange={(e) =>
                        handleChange(index, "REMARKS", e.target.value)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="text-center mt-4">
        <button
          className="btn btn-outline-success m-2 px-5"
          onClick={handleSubmit}
        >
          Upload
        </button>
      </div>
      <div className="p-3">
        {result && result.status === "ok" ? (
          <SuccessMsg
            head="Success"
            message={result.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={result.message || "Failed to complete the task"}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>
    </div>
  );
};

export default TWSBlockUpdate;
